import { toastError } from 'admination-react'
import { useState } from 'react'
import { useApp } from '@/core/state/appStore'

import { applyBewilligungUpload } from '../../../flows/bewilligung'
import { handleFailure } from '@/core/lib/toast'
import { UPLOAD_ACCEPT } from '@/core/lib/fileTypes'
import { DropCard } from '@/core/components/modal/DropCard'
import { ModalHeader } from '@/core/components/modal/ModalHeader'

export function BewilligungHochladen({ coachingId }: { coachingId: string | null }) {
  const { dispatch, reloadDashboard } = useApp()
  const [loading, setLoading] = useState(false)

  async function onFile(file: File) {
    if (!coachingId) return
    setLoading(true)
    try {
      const result = await applyBewilligungUpload(coachingId, file)
      if (!result.ok) {
        handleFailure(result)
        return
      }
      reloadDashboard()
      dispatch({ type: "CHANGE_TAB", tab: 'bewilligung' })
    } catch (e) {
      console.error("Bewilligung-Upload fehlgeschlagen:", e)
      toastError("Bewilligung-Upload fehlgeschlagen. Bitte erneut versuchen.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <ModalHeader size="document" onClose={() => dispatch({ type: 'CLOSE' })} />
      <DropCard
        title="Bewilligung hier ablegen"
        body="PDF oder Bild hierher ziehen oder auswählen"
        accept={UPLOAD_ACCEPT}
        onFile={onFile}
        loading={loading}
        loadingLabel="Bewilligung wird hochgeladen und ausgelesen …"
      />
    </>
  )
}
